export default "__VITE_ASSET__CrSBYe6r__"